import { render, staticRenderFns } from "./AllCollectionTaskQuery.vue?vue&type=template&id=5c9dbec4&scoped=true&"
import script from "./AllCollectionTaskQuery.vue?vue&type=script&lang=js&"
export * from "./AllCollectionTaskQuery.vue?vue&type=script&lang=js&"
import style0 from "./AllCollectionTaskQuery.vue?vue&type=style&index=0&id=5c9dbec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9dbec4",
  null
  
)

export default component.exports